import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, useDisclosure,
    MenuItem } from '@chakra-ui/react'
import { useRef, useState } from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import PDFProductsUndelivered from './PDFProductsUndelivered'
import { useNavigate } from "react-router-dom";
import authService from "../services/authService"

const PrintPDFProductsUndelivered = () => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    const initialRef = useRef(null)
    let [ form, setForm ] = useState({})

    const navigate = useNavigate();

    const handleOpen = () => {
        const accessToken = localStorage.getItem("user")
        
        fetch("https://api.veterinariacajeao.com.ar/api/product/products/undelivered", {
            headers: {
                'Content-Type': 'application/json',
                "x-auth-token": accessToken
            }
        })
        .then(response => response.json())
        .then(data => {
            setForm(form = {
                products: data
            })
        })
        .catch(error => {
            authService.logout()
            navigate("/");
            window.location.reload();
        })
        
        onOpen()
    }

    return (
        <>
            <MenuItem onClick={handleOpen}>Productos pendientes de entregar</MenuItem>

            <Modal
                initialFocusRef={initialRef}
                isOpen={isOpen}
                onClose={onClose}
                size='3xl'
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Listado de productos</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody pb={6}>
                        <PDFViewer width="720px" height="400px">
                            <PDFProductsUndelivered {...form}/>
                        </PDFViewer>
                    </ModalBody>

                </ModalContent>
            </Modal>
        </>
    )
}

export default PrintPDFProductsUndelivered